import { render, staticRenderFns } from "./FormExample.vue?vue&type=template&id=3670a8ac&scoped=true&"
import script from "./FormExample.vue?vue&type=script&lang=js&"
export * from "./FormExample.vue?vue&type=script&lang=js&"
import style0 from "./FormExample.vue?vue&type=style&index=0&id=3670a8ac&scoped=true&lang=css&"
import style1 from "./FormExample.vue?vue&type=style&index=1&id=3670a8ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3670a8ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCol,VIcon})
